import { Card } from "@/components/ui/card";
import { ResponsiveContainer } from "recharts";

interface ChartCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactElement;
}

export const ChartCard = ({ title, subtitle, children }: ChartCardProps) => {
  return (
    <Card className="p-5 stat-card overflow-hidden group">
      <div className="space-y-1.5 mb-6">
        <h3 className="text-lg font-medium">{title}</h3>
        {subtitle && (
          <p className="text-sm text-muted-foreground">{subtitle}</p>
        )}
      </div>
      <div className="h-[300px] relative">
        <div className="absolute inset-0 bg-gradient-to-t from-background/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
        <ResponsiveContainer width="100%" height="100%">
          {children}
        </ResponsiveContainer>
      </div>
    </Card>
  );
};